import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[luiNavigateBack]',
  standalone: true,
})
export class NavigateBackDirective {
  @HostListener('click') onCLick() {
    // this.router.navigate
    if (this.router.navigated) {
      this.location.back();
    } else {
      this.router.navigate(['../']);
    }
  }

  constructor(private location: Location, private router: Router) {}
}
